import { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination";
import UniversityWebTableRow from "./UniversityTableRow";
import { University_Table_Model } from "../../Models/universityModel";
function UniversityTable({
  University_Lists,
  LOADING,
  University_Lists_Get_Req,
  handleDeleteUniversity,
  handleEditUniversityData,
  setUniversity_Lists,
}) {
  const [UniversityPaginationTable, setUniversityPaginationTable] =
    useState(University_Lists);

  const [Page_data, setPage_data] = useState(10);

  const University_Table_Set = (page = 10) => {
    let New_data = [];
    for (let i = 0; i < University_Lists?.length; i++) {
      New_data.push(University_Lists[i]);
      if (i === page - 1) {
        break;
      }
    }
    setUniversityPaginationTable(New_data);
    setPage_data(page);
  };

  const SetPaginate_Page = (page) => {
    let New_data = [];
    for (let i = Page_data * (page - 1); i < University_Lists?.length; i++) {
      New_data.push(University_Lists[i]);
      if (New_data?.length === Page_data) {
        break;
      }
    }
    setUniversityPaginationTable(New_data);
  };

  useEffect(() => {
    University_Table_Set();
  }, [LOADING, University_Lists]);

  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
                {University_Table_Model?.map((el, i) => (
                  <th className="t-head-fixed" key={i}>
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-bordered">
              {UniversityPaginationTable?.map((el) => (
                <UniversityWebTableRow
                  key={el.Id}
                  {...el}
                  setUniversity_Lists={setUniversity_Lists}
                  University_Lists_Get_Req={University_Lists_Get_Req}
                  handleEditUniversityData={handleEditUniversityData}
                  handleDeleteUniversity={handleDeleteUniversity}
                />
              ))}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          <Pagination
            SetPaginate_Page={SetPaginate_Page}
            PaginationTable={Page_data}
            UniversityTable_Set={University_Table_Set}
            Total_Records={University_Lists?.length}
          />
        </div>
      </div>
    </div>
  );
}

export default UniversityTable;
